module.exports = __webpack_public_path__ + "img/检测通过.85112382.png";